import React, { useMemo } from "react";
import {
    TransactionRule,
    RuleActionType,
    filterVisibleRuleActions,
    sortTransactionRuleActions,
} from "@common/types/transactionRule";
import { Counterparty } from "@common/types/counterparty";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { RuleAction } from "./RuleAction/RuleAction";
import layoutStyles from "./RuleTagLayout.module.scss";

interface Props {
    rule: Pick<TransactionRule, "actions">;
    counterparties: Counterparty[];
}

export const TransactionRuleActions: React.FC<Props> = ({ rule, ...rest }) => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const { schedules: isSchedulesEnabled } = useTypedFlags();

    const actions = useMemo(
        () =>
            sortTransactionRuleActions(
                filterVisibleRuleActions(rule.actions ?? [], {
                    isGlFirst,
                }).filter(
                    (action) =>
                        isSchedulesEnabled ||
                        action.actionType !== RuleActionType.ASSIGN_TO_SCHEDULE,
                ),
            ),
        [rule.actions, isGlFirst, isSchedulesEnabled],
    );

    return (
        <div className={layoutStyles.grid}>
            {actions.map((action) => (
                <RuleAction
                    key={action.id}
                    action={action}
                    {...rest}
                    transferDirection={action.transferDirection}
                />
            ))}
        </div>
    );
};
